var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTech2FlowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 75,
    viewBox: "0 0 347.93 74.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#1b1c32;}.cls-3{fill:#00b2f2;}.cls-4{fill:url(#Degradado_sin_nombre_24);}.cls-5,.cls-8{mix-blend-mode:multiply;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#Degradado_sin_nombre_22);}.cls-7{fill:url(#Degradado_sin_nombre_24-2);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#Degradado_sin_nombre_22-2);}.cls-10{fill:url(#Degradado_sin_nombre_22-3);}.cls-11{fill:url(#Degradado_sin_nombre_22-4);}.cls-12{fill:url(#Degradado_sin_nombre_22-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_24",
    x1: -174.92,
    y1: 216.73,
    x2: -191.64,
    y2: 255.18,
    gradientTransform: "translate(237.58 -188.43) rotate(0.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -261.92,
    y1: 218.32,
    x2: -288.3,
    y2: 258.94,
    gradientTransform: "translate(326.61 -184.68) rotate(0.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2a2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22",
    x1: -180.09,
    y1: 252.27,
    x2: -197.11,
    y2: 263.56,
    gradientTransform: "translate(237.58 -188.43) rotate(0.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01f8f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006ef0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_24-2",
    x1: -189.77,
    y1: 206.87,
    x2: -208.79,
    y2: 241.42,
    xlinkHref: "#Degradado_sin_nombre_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -278.08,
    y1: 204.63,
    x2: -298.49,
    y2: 239.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-2",
    x1: -207.56,
    y1: 216.22,
    x2: -224.04,
    y2: 225.93,
    xlinkHref: "#Degradado_sin_nombre_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-3",
    x1: 427.43,
    y1: 595.84,
    x2: 444.44,
    y2: 632.43,
    gradientTransform: "translate(688.03 -375.77) rotate(90.83)",
    xlinkHref: "#Degradado_sin_nombre_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-4",
    x1: 417.35,
    y1: 622.17,
    x2: 435.45,
    y2: 660.07,
    gradientTransform: "translate(688.03 -375.77) rotate(90.83)",
    xlinkHref: "#Degradado_sin_nombre_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_22-5",
    x1: 391.17,
    y1: 622.11,
    x2: 407.95,
    y2: 659.91,
    gradientTransform: "translate(688.03 -375.77) rotate(90.83)",
    xlinkHref: "#Degradado_sin_nombre_22"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.49,52.1V32.61H97.72V28.34h20.86v4.27h-7.81V52.1Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.59,47.86h13.26V52.1H122.36V28.34h18v4.23h-12.8Zm-.7-9.84h12v4.07h-12Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.3,52.52a13.89,13.89,0,0,1-6.71-1.6,12.34,12.34,0,0,1-4.65-17,12.14,12.14,0,0,1,4.65-4.36,13.79,13.79,0,0,1,6.71-1.62,14.76,14.76,0,0,1,5.67,1,10.5,10.5,0,0,1,4.14,3l-3.41,3.28a9.17,9.17,0,0,0-2.83-2.14,7.91,7.91,0,0,0-3.4-.72,8.3,8.3,0,0,0-4.1,1,7.43,7.43,0,0,0-2.82,2.77,8.63,8.63,0,0,0,0,8.14,7.27,7.27,0,0,0,2.82,2.79,8.4,8.4,0,0,0,4.1,1,7.77,7.77,0,0,0,3.4-.73,9,9,0,0,0,2.83-2.13l3.41,3.28a10.52,10.52,0,0,1-4.16,3A14.8,14.8,0,0,1,157.3,52.52Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.84,52.1V28.34h5.24v9.55H188.5V28.34h5.24V52.1H188.5V42.21H177.08V52.1Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.72,52.1v-7L218,33.73a12.94,12.94,0,0,0,1.73-1.94,5.57,5.57,0,0,0,.75-1.48,4.67,4.67,0,0,0,.19-1.23,2.45,2.45,0,0,0-.82-2,3.8,3.8,0,0,0-2.48-.7,5.54,5.54,0,0,0-5,3.15l-8.63-4.31a14.26,14.26,0,0,1,5.53-5.67,17.65,17.65,0,0,1,9.16-2.19,18.28,18.28,0,0,1,7.13,1.31,11.32,11.32,0,0,1,4.84,3.69A9.19,9.19,0,0,1,232.14,28a13.81,13.81,0,0,1-.41,3.3,11,11,0,0,1-1.68,3.46,24.7,24.7,0,0,1-3.73,4l-9.21,8.39-1.79-4h17.59V52.1Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251,52.1h-5.24V28.34h18v4.23H251Zm-.63-13H262.3v4.24H250.37Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.57,52.1V28.34h5.24V47.82H286V52.1Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.61,52.52a13.88,13.88,0,0,1-6.76-1.62,12.17,12.17,0,0,1-4.67-4.41,11.79,11.79,0,0,1-1.7-6.31,11.61,11.61,0,0,1,1.7-6.28,12.27,12.27,0,0,1,4.67-4.36,13.79,13.79,0,0,1,6.71-1.62,13.93,13.93,0,0,1,6.76,1.62A12.14,12.14,0,0,1,312,33.9a11.78,11.78,0,0,1,1.68,6.28,11.88,11.88,0,0,1-6.33,10.72A13.82,13.82,0,0,1,300.61,52.52Zm-.05-4.45a8.17,8.17,0,0,0,4.06-1,7.25,7.25,0,0,0,2.76-2.79,8.34,8.34,0,0,0,1-4.11,7.9,7.9,0,0,0-1-4,7.61,7.61,0,0,0-2.76-2.76,7.79,7.79,0,0,0-4.06-1,7.7,7.7,0,0,0-4,1,7.6,7.6,0,0,0-2.81,2.76,7.71,7.71,0,0,0-1,4,8.14,8.14,0,0,0,1,4.11,7.25,7.25,0,0,0,2.81,2.79A8.08,8.08,0,0,0,300.56,48.07Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.54,52.1l-8-23.76H321l7,21.23H325.2l7.23-21.23h4.86l7,21.23H341.7l7.06-21.23h5.11l-8,23.76h-5.61l-6.24-18.82h1.42L329.15,52.1Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.4,34.89l-8-11.16L32.22,68.44h0c4.14,5.8,11.15,5,14.58-1.55Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.4,34.89l-8-11.16L32.22,68.44h0c4.14,5.8,11.15,5,14.58-1.55Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.54,53.29h0l-26.24,19c-6,4.33-13.36,2.76-18.08-3.85h0l26.24-19C64.45,45.1,71.82,46.67,76.54,53.29Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.54,16.23h0C46.4,10.43,39.4,11.17,36,17.78l-16.61,32h0c4.14,5.8,11.15,5,14.58-1.55Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.72,16.23h0c-4.15-5.8-11.15-5.06-14.58,1.55l-16.61,32h0c4.15,5.8,11.15,5,14.58-1.55Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.27,16.5h0L24,35.5c-6,4.33-13.35,2.76-18.08-3.85h0l26.25-19C38.17,8.31,45.54,9.88,50.27,16.5Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M90,43.54h0l-26.24,19c-6,4.33-13.36,2.76-18.08-3.85h0l26.24-19C77.91,35.36,85.28,36.93,90,43.54Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M55.71,23.39l8,11.17-26.24,19c-6,4.33-13.36,2.76-18.08-3.85h0Z",
    transform: "translate(-5.94 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M63.72,6.75h0l-26.24,19c-6,4.33-13.35,2.76-18.08-3.85h0l26.25-19C51.63-1.43,59,.14,63.72,6.75Z",
    transform: "translate(-5.94 -0.47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech2FlowLogo);
export default __webpack_public_path__ + "static/media/tech2flow-logo.1840e1ffe788ebf7e74dd83c05cd2dd2.svg";
export { ForwardRef as ReactComponent };